import { DraftRepresentative, IdentityType, RepresentativeRole } from '@blockpulse3/graphql/hooks';

import {
  spvLegalRepresentativePresidentSchema,
  spvLegalRepresentativeSchema,
  spvNaturalRepresentativeSchema,
} from '../../provider';

/**
 * isFormValid.
 * SPV.
 * Function to check if the current form is valid. Using a synchronous
 * yup validation function.
 *
 * @param {DraftRepresentative} rep
 * @returns {boolean}
 */
export function isFormValid(rep: DraftRepresentative): boolean {
  if (rep.type === IdentityType.COMPANY) {
    if (rep.role === RepresentativeRole.PRESIDENT) {
      return spvLegalRepresentativePresidentSchema.isValidSync(rep);
    }
    return spvLegalRepresentativeSchema.isValidSync(rep);
  }
  return spvNaturalRepresentativeSchema.isValidSync(rep);
}

/**
 * representantTitle.
 * SPV.
 * Function to return the "title" of the form.
 * For a legal one, it's the company name (.name) and firstName and lastName for a
 * natural one.
 *
 * @param {IRepresentantForm} rep
 * @returns {string}
 */
export function representantTitle(rep: DraftRepresentative): string {
  if (rep.type === IdentityType.COMPANY) {
    return rep.name || '';
  }
  return `${rep.firstName} ${rep.lastName}`;
}
